import { createSlice } from "@reduxjs/toolkit";
import { GeoJson, Sidos } from "src/utils/data";
import { RegionScopes } from "src/utils/region-scope";

const initialState = {
  sidos: new Sidos([], []),
  sidosInit: false,
  analysisSidos: new Sidos([], []),
  analysisSidosInit: false,
  // DataLake request factory용 구조는 CInfo 포함 지역 트리와 분리해 저장한다.
  structureSidos: new Sidos([], []),
  structureSidosInit: false,
  analysisStructureSidos: new Sidos([], []),
  analysisStructureSidosInit: false,
  regionMap: {
    sidos: new Map(),
    gungus: new Map(),
    dongs: new Map(),
  },
  sidoNames: [],
  sidoNamesOnly: [],
  sidoNamesForGungu: [],
  gunguNames: [],
  geojson: {},
  geojsonInit: false,
  // gungu 는 아래 형식 리스트로 옴
  // { compareName: "강북14개구";
  // groupNames: ["전국", "서울시", "수도권"];
  // name: "종로구";
  // nameWithSidoName: "종로구";
  // sidoName: "강북14개구"};
  // selectedGungus 는 ["시도이름", "군구이름"] 형식으로 저장됨
};

const reducers = {
  getSidos(state, action) {
    const { scope = RegionScopes.DEFAULT, dto } = action.payload;
    if (scope === RegionScopes.ANALYSIS) {
      state.analysisSidos = new Sidos(dto.sidos, dto.groups);
      state.analysisSidosInit = true;
      return;
    }
    state.sidos = new Sidos(dto.sidos, dto.groups);
    state.sidosInit = true;
  },
  /** CInfo 없는 경량 지역 구조를 기존 화면용 지역 트리와 분리해 저장한다. */
  getSidosStructure(state, action) {
    const { scope = RegionScopes.DEFAULT, dto } = action.payload;
    if (scope === RegionScopes.ANALYSIS) {
      state.analysisStructureSidos = new Sidos(dto.sidos, dto.groups);
      state.analysisStructureSidosInit = true;
      return;
    }
    state.structureSidos = new Sidos(dto.sidos, dto.groups);
    state.structureSidosInit = true;
  },
  getSidosNames(state, action) {
    state.sidoNames = action.payload.sidoNames;
    state.sidoNamesForGungu = action.payload.sidoNamesForGungu;
    state.gunguNames = action.payload.gunguNames;
    state.sidoNamesOnly = action.payload.sidoNamesOnly;
  },
  getGeoJson(state, action) {
    state.geojson = {
      sidoGeoJson: new GeoJson(action.payload.sidoGeoJson),
      gunguGeoJson: new GeoJson(action.payload.gunguGeoJson),
    };
    state.geojsonInit = true;
  },
};

export const slice = createSlice({
  name: "region",
  initialState,
  reducers,
});

export const { reducer } = slice;
